var swiper = new Swiper.default('.swiper-container', {
  loop: true,
  navigation: {
    nextEl: '.main-slider .swiper-button-next',
    prevEl: '.main-slider .swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }

});


var recSwiper = new Swiper.default('.recommendations-slider', {
  loop: true,
  autoplay: {
    delay: 5000
  },
  navigation: {
    nextEl: '.recommendations-slider .swiper-button-next',
    prevEl: '.recommendations-slider .swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }

});